import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios"
import { getToken, removeDataLocalStorage } from "./auth_helper"

if (!process.env.REACT_APP_API_URL) {
  throw new Error("REACT_APP_API_URL is not defined. Build aborted.");
}

const API_URL = process.env.REACT_APP_API_URL;

export const axiosApi = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

axiosApi.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers["Authorization"] = token;
  }
  return config;
});

axiosApi.interceptors.response.use(
  (response: AxiosResponse) => {
      return response;
  },
  (error: AxiosError) : Promise<AxiosError> => {
      if (error?.response?.status === 401) {
          removeDataLocalStorage();
          window.location.href = "/login";
      } 
      return Promise.reject(error);
  }
);

export type ResponseApi<T> = {
  code: number
  data?: T
  message: string
}

export async function get<T>(url : string, config: AxiosRequestConfig = {}): Promise<ResponseApi<T>> {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post<T>(url : string, data : any, config: AxiosRequestConfig = {}): Promise<ResponseApi<T>> {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function patch<T>(url : string, data : any, config: AxiosRequestConfig = {}): Promise<ResponseApi<T>> {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function put<T>(url : string, data : any, config: AxiosRequestConfig = {}): Promise<ResponseApi<T>> {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then(response => response.data)
}

export async function del<T>(url : string, config: AxiosRequestConfig = {}): Promise<ResponseApi<T>> {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}

export const extractErrorMessage = (err: any) => {
  let message: string = '';
  const resError = err?.response?.data ;

  try {
      if (resError.errors && (typeof resError.errors === 'object' && resError.errors !== null) && Object.keys(resError.errors).length > 0) {

          Object.keys(resError.errors).forEach((key) => {
              const error: string = Array.isArray(resError.errors[key]) ? resError.errors[key][0] : `${resError.errors[key]}`;
              // message.push(error);
              message = error;
          });
      } else if (resError?.errors && (typeof resError?.errors === 'string')) {
          message = resError.errors;
      } else if (resError?.message) {
          message = resError.message;
      } else {
          message = err?.error?.description || err?.error?.message || err?.statusText;
      }
  } catch (error) {
      message = err?.error?.description || err?.error?.message || err?.statusText;
  }

  return message;
}
